import { render, staticRenderFns } from "./CoachSettingCoachingBio.vue?vue&type=template&id=5dd957ab&"
import script from "./CoachSettingCoachingBio.vue?vue&type=script&lang=ts&"
export * from "./CoachSettingCoachingBio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports